module.exports = __webpack_public_path__ + "img/imagen_portada_video1.08eecb2e.webp";